/**
 * Reads a multilingual field value and returns the text for the given language.
 * Falls back to 'de' if the requested language has no value.
 * Also handles legacy plain strings by returning them as-is.
 *
 * @param {string|Object} value  - Either a plain string or {de: "...", en: "...", pl: "..."}
 * @param {string}        lang   - Current language code, e.g. "de", "en", "pl"
 * @param {string}        fallbackLang - Fallback language code (default: "de")
 * @returns {string}
 */
export function getLocalizedText(value, lang, fallbackLang = "de") {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value[lang] || value[fallbackLang] || "";
}
